import { render } from "./FleetModelItem.vue?vue&type=template&id=56d61337"
import script from "./FleetModelItem.vue?vue&type=script&lang=js"
export * from "./FleetModelItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__